<template>
    <div class="modal is-active folder-modal">
        <div class="modal-background" />
        <div class="modal-content px-0 py-0">
            <div class="box">
                <div class="logo-app px-6 mx-4 pb-4">
                    <img
                        :src="require('@/assets/images/logo_eduloc360_red.png')"
                        class="mt-4"
                    />
                </div>

                <div class="px-4 mx-6 pb-5">
                    <img
                        :src="type.image"
                        class="mt-3"
                    />
                </div>

                <p class="is-size-4 has-text-centered pb-5">
                    {{ $t(`new_${type.name}`) }}
                </p>

                <div class="field">
                    <p class="control">
                        <input
                            v-model="projectData.title"
                            :placeholder="$t('creation.title_hint')"
                            class="input project-name"
                            type="text"
                        />
                    </p>
                </div>
                <div class="field">
                    <p class="control">
                        <textarea
                            v-model="projectData.description"
                            :placeholder="$t('describe_your_project')"
                            class="textarea project-description"
                        />
                    </p>
                </div>
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field">
                            <p
                                v-t="'enabled_languages'"
                                class="label secondary-font has-text-black-light"
                            />
                            <multiselect 
                                class="select-lang secondary-font" 
                                v-model="projectData.langs" 
                                :options="langCodes" 
                                :custom-label="langLabel" 
                                :multiple="true"
                                :selectLabel="$t('select_langs_select')"
                                :selectedLabel="$t('select_langs_selected')"
                                :deselectLabel="$t('select_langs_deselect')"
                                :placeholder="$t('select_langs')"
                                ></multiselect>
                        </div>
                        
                    </div>
                    <div class="column is-12 pt-0" v-if="projectData.langs && projectData.langs.length">
                        <div class="field">
                            <p
                                v-t="'default_language'"
                                class="label has-text-black-light secondary-font"
                            />
                            <multiselect 
                                class="select-lang" 
                                v-model="projectData.defaultLang" 
                                :options="projectData.langs" 
                                :custom-label="langLabel" 
                                :multiple="false"
                                :selectLabel="$t('select_langs_select')"
                                :selectedLabel="$t('select_langs_selected')"
                                :deselectLabel="$t('select_langs_deselect')"
                                :placeholder="$t('select_langs')"
                                ></multiselect>
                        </div>
                        <p class="is-muted is-size-7 has-text-black-light secondary-font">{{ $t('default_language_desc') }}</p>
                    </div>
                </div>
                <div class="level py-4">
                    <div class="level-left">
                        <button
                            class="level-item button is-right has-background-grey-light has-text-black"
                            @click="$emit('cancel')"
                        >
                            {{ $t('Buttons.cancel') }}
                        </button>
                    </div>
                    <div class="level-right">
                        <button
                            class="level-item button is-left has-background-eduloc-green has-text-white"
                            @click="createProject"
                        >
                            {{ $t('Buttons.save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import { LANG_CODES } from '@/lib/constants';
export default {
    components: {},
    props: {
        type: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            projectData: {
                title: '',
                description: '',
            },
        };
    },
    computed: {
        langCodes() {
            return LANG_CODES;
        },
    },
    mounted() {},
    methods: {
        createProject() {
            if(!this.projectData.title.length){
                Swal.fire({
                    text: this.$t('project.missing_title_value'),
                    confirmButtonColor: '#014c6c',
                    confirmButtonText: this.$t('Buttons.return'),
                })
            }else if(!this.projectData.description.length){
                Swal.fire({
                    text: this.$t('project_missing_description_value'),
                    confirmButtonColor: '#014c6c',
                    confirmButtonText: this.$t('Buttons.return'),
                })
            }else if(!this.projectData.langs || !this.projectData.defaultLang){
                Swal.fire({
                    text: this.$t('project_missing_langs_value'),
                    confirmButtonColor: '#014c6c',
                    confirmButtonText: this.$t('Buttons.return'),
                })
            }else if((this.projectData.langs && !this.projectData.langs.length) || (this.projectData.defaultLang && !this.projectData.defaultLang.length)){
                Swal.fire({
                    text: this.$t('project_missing_langs_value'),
                    confirmButtonColor: '#014c6c',
                    confirmButtonText: this.$t('Buttons.return'),
                })
            }else{
                this.$emit('create', this.projectData);
            }
        },
        langLabel(code) {
            return this.$t("LANG_" + code);
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.project-name::placeholder, .project-description::placeholder{
    color: var(--eduloc-grey);
}
.select-lang /deep/ .multiselect__element{
    font-family: 'inter_regular';
}
.select-lang /deep/ .multiselect__placeholder{
    font-family: 'inter_regular';
}
.select-lang /deep/ .multiselect__single{
    font-family: 'inter_regular';
}
.select-lang /deep/ .multiselect__content-wrapper{
    position:relative;
    max-height: 200px;
}
.select-lang /deep/ .multiselect__input{
    font-size: 1rem;
    font-family: 'inter_regular';
}
.select-lang /deep/ .multiselect__option{
    font-size: 1rem;
}
.select-lang /deep/ .multiselect__tag{
    background: var(--eduloc-red);
    font-family: 'inter_regular';
}
.select-lang /deep/ .multiselect__tag-icon:after{
    color: #FFFFFF;
}
.select-lang /deep/ .multiselect__tag-icon:focus, .select-lang /deep/ .multiselect__tag-icon:hover{
    background: var(--eduloc-red-dark);
}
.select-lang /deep/ .multiselect__option--highlight, .select-lang /deep/ .multiselect__option--highlight::after{
    background: var(--eduloc-red);
}
</style>
